// extracted by mini-css-extract-plugin
export default {"borderLight":"#e5e9f2","borderLightAlt":"#b7c2d0","borderDark":"#3c4d62","borderDarkAlt":"#344357"};